import React from 'react';

const money = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
const plates = (n) => `${n} plate${Number(n) === 1 ? '' : 's'}`;

/** What Confirm will do for one dish — computed by the server's own planner. */
export default function DishPreview({ preview: p, busy = false, onConfirm, onCancel }) {
  const mismatchIds = new Set((p.unit_mismatches || []).map((m) => Number(m.ingredientId)));
  const blockedByUnits = !!p.strict_unit_family && (p.unit_mismatches || []).length > 0;
  const disabled = busy || p.no_recipe || blockedByUnits;
  const shortages = p.shortages || [];

  return (
    <div className="nim-preview" aria-label={`Preview for ${p.item_name}`}>
      <div className="um-name">{p.item_name} <span className="um-muted">→</span> {p.menu_item.name}</div>
      <div className="um-sub">
        {p.deduct_plates > 0 && <span className="um-deduct-tag">Will deduct · {plates(p.deduct_plates)}</span>}
        {p.absorbed_plates > 0 && <span className="um-absorb-tag">Already counted · {plates(p.absorbed_plates)} (revenue only, stock unchanged)</span>}
        {p.nc_plates > 0 && <span className="sd-unmapped-badge">NC — no revenue</span>}
        {p.promote_amount > 0 && <span className="um-muted"> · {money(p.promote_amount)} will be added to sales</span>}
      </div>
      {p.absorbed_plates > 0 && p.last_count && (
        <p className="um-muted">Sales up to {p.last_count.closing_date} are already in that day’s closing count, so only their revenue is added.</p>
      )}
      {p.no_recipe && <div className="um-warn">{p.menu_item.name} has no recipe — add its ingredients in Item Map, then confirm.</div>}
      {blockedByUnits && <div className="um-warn">Some recipe lines use a unit that doesn’t match the ingredient’s stock unit. Fix them in Item Mapping first.</div>}
      {!p.no_recipe && (p.ingredients || []).length > 0 && (
        <table className="um-ing-table">
          <thead>
            <tr>
              <th className="nim-th-ingredient">Ingredient</th>
              <th className="nim-th-total">Total</th>
            </tr>
          </thead>
          <tbody>
            {p.ingredients.map((i) => (
              <tr key={`${i.item_id}-${i.preparation || ''}`}>
                <td className="nim-td-ingredient">
                  {i.name}
                  {i.preparation && <span className="um-muted"> (from {i.preparation})</span>}
                  {mismatchIds.has(Number(i.item_id)) && <span className="nim-mismatch"> ⚠ unit mismatch — nothing deducted</span>}
                </td>
                <td className="nim-td-total">{i.total} {i.unit}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {shortages.length > 0 && (
        <div className="um-warn">Not enough stock for {shortages.length} ingredient{shortages.length === 1 ? '' : 's'}. You’ll be asked before stock goes negative.</div>
      )}
      {p.count_in_progress && (
        <p className="um-muted">A closing count is in progress — this saves the dish now and settles its stock when the count is applied.</p>
      )}
      <div className="nim-preview-actions">
        <button type="button" className="nim-preview-cancel-btn" onClick={onCancel} disabled={busy}>Cancel</button>
        <button type="button" className="nim-preview-confirm-btn" onClick={onConfirm} disabled={disabled}>
          {p.count_in_progress ? 'Save — settles when the count is applied' : 'Confirm & deduct'}
        </button>
      </div>
    </div>
  );
}
